// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__zxrto","input":"checkbox_input__P6u0V","disabled":"checkbox_disabled__R3k8c"};